import React, { Component } from "react";
import { Row, Col, Card, Table } from "reactstrap";
import CgnAlert from "../toolbox/CgnAlert";
import CgnLoader from "../toolbox/CgnLoader";
import CgnButtonLink from "../toolbox/CgnButtonLink";
import ContentTop from "../root/ContentTop";
import axios from "axios";
import {  URL } from "../../redux/actions/constants";

class AssignmentDetail extends Component {
  state = {
    pageTitle: "İş Atama Detay",
    pageTitleDetail: "İş Atama Detay",
    pageAddLink: "is-atama-ekle",
    pageListLink: "is-atama-listele",
    breadcrumb: [{ text: "İş Atama", link: "#" }],
    isLoading: false,
    alertErrorMessage: "",
    guid: "",
    faultStatusName: "",
    machineSerialNo: "",
    brandName: "",
    modelName: "",
    personelName: "",
    customerName: "",
    complaintReasonName: "",
    complaintDescription: "",
    wageStatus: "",
    status: "",
    createdBy: "",
    createdAt: "",
    updatedAt: "",
    updatedBy: "",
  };

  async componentDidMount() {
    let urlSplit = window.location.pathname.split("/");
    if (urlSplit.length === 3) {
      this.setState({
        pageTitle: this.state.pageTitleDetail,
        isLoading: true,
      });
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      axios
        .get(URL + "/assignment/get/" + urlSplit[2], config)
        .then((response) => {
          this.setState({
            faultStatusName: response.data.faultStatusName,
            machineSerialNo: response.data.machineSerialNo,
            brandName: response.data.brandName,
            modelName: response.data.modelName,
            complaintReasonName: response.data.complaintReasonName,
            complaintDescription: response.data.complaintDescription,
            wageStatus: response.data.wageStatus,
            personelName: response.data.personelName,
            customerName: response.data.customerName,
            status: response.data.status,
            createdBy: response.data.createdBy,
            createdAt: response.data.createdAt,
            updatedBy: response.data.updatedBy,
            updatedAt: response.data.updatedAt,
            isLoading: false,
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    }
  }

  render() {
    return (
      <>
        <ContentTop
          breadcrumb={this.state.breadcrumb}
          title={this.state.pageTitle}
          addLink={"/" + this.state.pageAddLink}
          listLink={"/" + this.state.pageListLink}
        />
        <Row>
          <Col>
            <Card body className="table-responsive">
              <CgnLoader visibled={this.state.isLoading} />
              {this.state.alertErrorMessage && (
                <CgnAlert
                  color="danger"
                  title="Uyarı"
                  text={this.state.alertErrorMessage}
                />
              )}
              <Table className="table table-responsive table-hover">
                <tbody>
                  <tr>
                    <th>Makine</th>
                    <td colSpan="4">
                      {this.state.brandName + " / " + this.state.modelName + " / " + this.state.machineSerialNo}
                    </td>
                  </tr>

                  <tr>
                    <th>İlgili Personel</th>
                    <td colSpan="4">
                      {this.state.personelName ? this.state.personelName : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>Müşteri</th>
                    <td colSpan="4">
                      {this.state.customerName ? this.state.customerName : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>Arıza Durumu</th>
                    <td colSpan="4">
                      {this.state.faultStatusName ? this.state.faultStatusName : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>Şikayet Sebebi</th>
                    <td colSpan="4">
                      {this.state.complaintReasonName ? this.state.complaintReasonName : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>Ücret Durumu</th>
                    <td colSpan="4">
                      {(this.state.wageStatus === 1
                              ? "Ücretli"
                              : this.state.wageStatus === 2
                              ? "Ücretsiz"
                              : "-")}
                    </td>
                  </tr>
                  <tr>
                    <th>Şikayet Sebebi Açıklama</th>
                    <td colSpan="4">
                      {this.state.complaintDescription ? this.state.complaintDescription : "-"}
                    </td>
                  </tr>

                  <tr>
                    <th>Durumu</th>
                    <td colSpan="4">{this.state.status ? "Aktif" : "Pasif"}</td>
                  </tr>

                  <tr>
                    <th>Kaydeden Kullanıcı</th>
                    <td>{this.state.createdBy ? this.state.createdBy : "-"}</td>
                    <th>Kaydedilme Tarihi</th>
                    <td>{this.state.createdAt ? this.state.createdAt : "-"}</td>
                  </tr>
                  <tr>
                    <th>Son Güncelleyen Kullanıcı</th>
                    <td>{this.state.updatedBy ? this.state.updatedBy : "-"}</td>
                    <th>Son Güncellenme Tarihi</th>
                    <td>{this.state.updatedAt ? this.state.updatedAt : "-"}</td>
                  </tr>
                </tbody>
              </Table>
            </Card>
            <CgnButtonLink
              color="secondary"
              to={"/" + this.state.pageListLink}
              text="Geri"
              className="btn-back"
            />
          </Col>
        </Row>
      </>
    );
  }
}

export default AssignmentDetail;
